<script>
export default {
  name: 'nav',
  computed: { 
    SidebarAdminItems () {
      return [{
        _name: 'CSidebarNav',
        _attrs: { style: 'color: #000;' },
        _children: [
          {
            _name: 'CSidebarNavTitle',
            _children: ['Administador'],
            _attrs: {style:"background-color: #929C8B !important;"}
          },
          {
            _name: 'CSidebarNavItem',
            name: 'Cuentas',
            to: '/admin/accounts',
            icon: 'cil-group',
          },
          {
            _name: 'CSidebarNavItem',
            name: 'Horarios de envío',
            to: '/admin/send-time-report',
            icon: 'cil-chart-pie',
          },
          {
            _name: 'CSidebarNavItem',
            name: 'Botón de emergencia',
            to: '/admin/emergency-control',
            icon: 'cil-warning',
          }
        ]
      }]
    }
  }
}
</script>
